import { Card, CardActionArea, CardContent, Stack, Typography } from '@vapor/material'
import { Currency } from 'src/api/currency'
import useFormatCurrency from 'src/app/hooks/current-locale/use-format-currency'
import './style.css'

type PosProductCardProps = {
  name: string
  price: number
  currency: Currency
  disabled: boolean
  onClick: () => void
}

export default function PosProductCard(props: PosProductCardProps) {
  const { name, price, currency, disabled, onClick } = props
  const { formatCurrency } = useFormatCurrency()
  return (
    <Card sx={{ maxWidth: '100%', height: '100%' }}>
      <CardActionArea disabled={disabled} onClick={onClick} style={{ height: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'flex-start' }}>
        <CardContent style={{ height: '100%', width: '100%', boxSizing: 'border-box', padding:8 }} className='posMenuItem'>
          <Stack direction="column" sx={{ height: '100%', width: '100%', justifyContent: 'space-between' }}>
            <Typography variant="body" gutterBottom sx={{ wordBreak: 'break-word', fontSize:{xs:12, sm:14, md:'1rem'} }}>
              <b>{name}</b>
            </Typography>
            <Typography gutterBottom sx={{ alignSelf: 'flex-end', fontSize:{xs:12, sm:14, md:'1rem'} }}>
              {formatCurrency(price, currency)}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
